import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import leasingLogo from '../images/nordania-leasing-logo.svg';
import finansLogo from '../images/nordania-finans-logo.svg';

const useStyles = makeStyles({
  logo: {
    width: "235px",
  },
})

export default function Logo() {
  const classes = useStyles();
  const pathname = window.location.pathname;
  const isNordaniaFinansForm = pathname.indexOf('/repayment-private') === 0 || pathname.indexOf('/repayment-vendor') === 0;
  const logo = isNordaniaFinansForm ? finansLogo : leasingLogo;
  const altText = isNordaniaFinansForm ? "Nordania Finans" : "Nordania Leasing";
  return (
    <Link to="#">
      <img src={logo} className={classes.logo} alt={altText}/>
    </Link>
  );
}
